import * as _ from 'lodash';

import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';
import { OpportunitySchemaUtil } from '@features/opportunities/modules/core/utils/opportunity-schema-util';
import { IdObjectValue } from '@shared/models/schema-property-definition';
import { Applicant } from './applicant';

export namespace SharePercentage {
  export interface SchemaPropertyDefinition {
    share: OpportunitySchema.NumberPropertyDefinition;
  }
  export interface SchemaContract {
    share: number | null;
  }
  export interface Model {
    share: number | null;
  }

  export namespace Collection {
    export type SchemaContract =
      IdObjectValue.SchemaContractCollection<SharePercentage.SchemaContract>;
    export type Model = IdObjectValue.ModelCollection<SharePercentage.Model>;
    export function toModel(c: SchemaContract, entityPath?: string): Model {
      return _.keys(c).reduce((r, id) => {
        const entityId = entityPath ? `${entityPath}/${id}` : id;
        r[entityId] = {
          share: c[id]?.share ?? null
        };
        return r;
      }, {} as Model);
    }

    export function toSchemaContract(
      m: Model,
      removeEntityPath: boolean = false
    ): SchemaContract {
      return _.keys(m).reduce((r, entityId) => {
        const id = removeEntityPath
          ? OpportunitySchemaUtil.idFromReference(entityId)
          : entityId;
        r[id] = {
          share: m[entityId]?.share ?? null
        };
        return r;
      }, {} as Model);
    }

    export function enrich(
      model: SharePercentage.Collection.Model,
      otherApplicants: Applicant.Summary[]
    ): SharePercentage.Collection.Model {
      const enrichedModel: SharePercentage.Collection.Model = {};
      otherApplicants.forEach((a) => {
        const ownership = model[a.id];
        enrichedModel[a.id] = {
          share: ownership ? ownership.share : null
        };
      });
      return enrichedModel;
    }
  }
}
